module.exports = __webpack_public_path__ + "static/media/game-press-symbol-employment.33dc9a93.png";